export default __webpack_public_path__ + "static/media/certificateTemporaty.251e8979.jpg";